import { useEffect, useState } from 'react'
import { activity_dates, concourseId } from '../constants/activity-constants'
import GameServices from '../services/game-service'

async function requestConcourseDates() {
  if (typeof window === 'undefined') {
    return activity_dates
  }
  if (!concourseId) {
    return activity_dates
  }
  let ipAddress = sessionStorage.getItem('ipAddress')
  if (!ipAddress) {
    ipAddress = '127.0.0.1'
  }
  const config = {
    headers: {
      'Ip-Address': ipAddress,
    },
  }
  try {
    const res: any = await GameServices.getConcourseInfo(concourseId, config)
    if (res.status === 200) {
      // console.log('home call res: ', res.data)
      activity_dates[0] = res.data.startDate
      activity_dates[1] = res.data.endDate
    }
  } catch (error) {
    console.warn('concourse Info error: ', error)
  }
  return activity_dates
}

export default function useActivityDates() {
  const [dates, setDates] = useState([...activity_dates])
  useEffect(() => {
    let active = true
    requestConcourseDates().then(dates => {
      if (active) {
        setDates(dates)
      }
    })
    return () => {
      active = false
    }
  }, [])

  return dates
}
